import React, { useEffect, useMemo, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { IoAppsOutline } from "react-icons/io5";
import { useLanguage } from "../Translations/LenguageContext";
import AppTypeModal from "./AppTypeModal";
import { useNavigate, useParams } from "react-router-dom";
import ItemsLoader from "../Loaders/ItemsLoading";
import { GrAscend, GrDescend } from "react-icons/gr";
import { TbReload } from "react-icons/tb";
import { PiMagnifyingGlass } from "react-icons/pi";
import { LuTrash2 } from "react-icons/lu";
import { Dropdown } from "react-bootstrap";
import { ImNewTab } from "react-icons/im";
import DeleteItemModal from "../Components/DeleteItemModal";

const MainApps = ({ account_id, appData, fetchAppData, loadingAppData, setOpenSidebar }) => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const { org_id } = useParams()
    const [openModal, setOpenModal] = useState(false)
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [openDeleteItem, setOpenDeleteItem] = useState(false)
    const [selectedItem, setSelectedItem] = useState({})

    useEffect(() => {
        fetchAppData(org_id)
    }, [])

    const filteredAndSortedData = useMemo(() => {
        if (!appData) return [];

        let result = appData.filter((item) => {
            const term = searchTerm.toLowerCase();
            const nameMatch = item.name?.toLowerCase().includes(term);
            const descMatch = item.description?.toLowerCase().includes(term);
            const permission = item.permission?.toLowerCase().includes(term);

            return nameMatch || descMatch || permission;
        });

        result.sort((a, b) => {
            const nameA = a.name?.toLowerCase() || "";
            const nameB = b.name?.toLowerCase() || "";
            if (sortOrder === "asc") {
                return nameA.localeCompare(nameB);
            } else {
                return nameB.localeCompare(nameA);
            }
        });

        return result;
    }, [appData, searchTerm, sortOrder]);

    const openAppWorkspace = (type, app_id, version) => {
        navigate(`/e8console/organizations/${org_id}/apps/app-builder/${type}/${app_id}/${version}`)
        setOpenSidebar(false)
    }

    if (loadingAppData) {
        return <ItemsLoader />;
    }

    return (
        <div className="mainframe_item" >
            <div className="mainframe_item_header" >
                <p className="mainframe_item_title fade-in">{t.apps.title}</p>
                <div className="mainframe_item_subtitle fade-in">
                    {appData.length === 0 ? (
                        <div className="empty_org_mex_cont">
                            <p>{t.apps.empty_subtitle}</p>
                            <div className="empty_org_img">
                                <p className="empty_org_img_title">
                                    <i><IoAppsOutline /></i> {t.apps.quest_title}
                                </p>
                                <p className="empty_org_img_subtitle">{t.apps.quest_answ}</p>
                            </div>
                        </div>
                    ) : (
                        <p>{t.apps.subtitle}</p>
                    )}
                </div>
                {/* <button
                    className={`mainframe_item_create_btn fade-in ${appData.length === 0 && "mainframe_item_create_btn_anim"}`}
                    onClick={() => setOpenModal(true)}
                >
                    <BiPlus /> {t.create}
                </button> */}
                <p className="soon_av">Soon available</p>
            </div>
            {(appData.length > 0 || searchTerm) && (
                <div className="filter_body_mainframe">
                    <div className="filtering_mainframe">
                        <div className="filtering_mainframe_btn_cont fade-in">
                            {appData.length > 1 && (
                                <>
                                    <button
                                        className={`filter_btn ${sortOrder === "asc" ? "active" : ""}`}
                                        onClick={() => setSortOrder("asc")}
                                        title="A-Z"
                                    >
                                        <GrAscend />
                                    </button>
                                    <button
                                        className={`filter_btn ${sortOrder === "desc" ? "active" : ""}`}
                                        onClick={() => setSortOrder("desc")}
                                        title="Z-A"
                                    >
                                        <GrDescend />
                                    </button>
                                </>
                            )}
                            <button
                                className="filter_btn"
                                onClick={() => fetchAppData()}
                                title={t.reload}
                            >
                                <TbReload />
                            </button>
                        </div>
                        <div className="filter_input_cont fade-in">
                            <input
                                className="filter_input"
                                placeholder={t.search_filter}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                        </div>
                    </div>

                    <div className="organizations_cont">
                        {filteredAndSortedData.length > 0 ? (
                            <div className="organizations_cont_inner">
                                {filteredAndSortedData.map((item) => (
                                    <div
                                        key={item.id}
                                        className="app_item fade-in"
                                    >
                                        <div className="app_item_preview">
                                            <iframe
                                                src={item.default_url}
                                                title="Website preview"
                                                width="100%"
                                                height="100%"
                                                frameBorder="0"
                                            />
                                        </div>
                                        <div className="app_item_footer">
                                            <div className="app_item_footer_inner">
                                                <p className="app_item_title" title={item.name}>
                                                    {item.name}
                                                </p>
                                                <p className="app_item_desc" title={item.description}>
                                                    {item.description}
                                                </p>
                                            </div>
                                            <div className="app_item_footer_inner">
                                                <Dropdown drop="down" autoClose={"outside"}>
                                                    <Dropdown.Toggle as="div" className="app_dropdown fade-in pointer">

                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu className="custom_dropdown_menu">
                                                        <div className="scrollable_dropdown_cont">
                                                            <a
                                                                href={item.default_url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="settings_link"
                                                            >
                                                                <ImNewTab /> Open app 
                                                            </a>
                                                            <div
                                                                className={`settings_link`}
                                                                onClick={()=> openAppWorkspace(item.type, item.id, item.version)}
                                                            >
                                                                <IoAppsOutline/> Open workspace
                                                            </div>
                                                            <div
                                                                className={`settings_link settings_link_delete`}
                                                                onClick={()=> (setOpenDeleteItem(true), setSelectedItem(item))}
                                                            >
                                                                <LuTrash2/> Delete app
                                                            </div>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="organizations_cont_no_items_mex fade-in">
                                <p>{t.no_data_found_by_search}</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <AppTypeModal
                account_id={account_id}
                show={openModal}
                handleClose={() => setOpenModal(false)}
                setOpenSidebar={setOpenSidebar}
            />

             <DeleteItemModal
                account_id={account_id}
                show={openDeleteItem}
                handleClose={() => setOpenDeleteItem(false)}
                fetchRecords={fetchAppData}
                item={selectedItem}
                endpoint={"delete_app"}
                title={"Delete app?"}
                description={"Deleting this API key will permanently revoke access. Any applications or services using it will stop working immediately. This action cannot be undone."}
                input_value={selectedItem}
            />
        </div>
    )
}

export default MainApps